import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbDateStruct, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { DateUtilsService } from "src/app/_services/dateUtils";
import { PosService } from "src/app/_services/posService";
import { InvoiceService } from "./../../../../_services/invoice.service";
import { Config } from "src/app/_store/config";

@Component({
  selector: "app-ds-credit-note-upload-preview",
  templateUrl: "./ds-credit-note-upload-preview.component.html",
  styleUrls: ["./ds-credit-note-upload-preview.component.scss"],
})
export class DsCreditNoteUploadPreviewComponent implements OnInit {
  @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
  Config = Config;
  invoiceDetails: any;
  invoiceType: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  invoiceSaved: boolean = false;
  uploadInvoice: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  displayName: any;
  hasError = false;
  safeUrl: SafeResourceUrl = "";
  pdfSrc: any;
  fileLink: any;
  fileSizeError = false;
  fileTypeError = false;
  typeError = false;
  sizeError = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  responseData: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  poNo: any;
  eInvoice = false;
  formData: any;
  DocDt: NgbDateStruct;
  model: NgbDateStruct;
  irnExist: boolean = false;
  dsLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  canSubmitForm = false;
  allDeleted = false;
  isInvoice = false;
  isNonPOInvoice = false;
  intialLoading = false;
  emptyPo = false;
  poType;
  companyCode = "";
  purchaseOrg;
  docType;

  poResponseData;
  poItems = [];
  invList: any;

  digitalNote = new FormGroup({
    SellerGstin: new FormControl("", [Validators.required, Validators.minLength(15), Validators.maxLength(15)]),
    file_link: new FormControl(""),
    barcode: new FormControl("", []),
    BuyerGstin: new FormControl(""),
    DocNo: new FormControl("", [Validators.required]),
    PoNo: new FormControl("", [Validators.required]),
    DocTyp: new FormControl(""),
    Doctype: new FormControl("", [Validators.required]),
    DocDt: new FormControl("", [Validators.required]),
    TotInvVal: new FormControl(null, [
      Validators.required,
      Validators.pattern("^([0-9]+(.?[0-9]?[0-9]?)?)"),
    ]),
    ItemCnt: new FormControl(""),
    Irn: new FormControl("", [Validators.minLength(64), Validators.maxLength(64)]),
    IrnDt: new FormControl(""),
    MainHsnCode: new FormControl(""),
    file: new FormControl(""),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
  });
  barcodes: any[];

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private poService: PosService,
    private sanitizer: DomSanitizer,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  setAsDirty() {
    this.digitalNote.controls["Irn"].markAsDirty;
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  selectDocuments(event: any) {
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > Config.maxTotalSupportingDocsSize) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
      this.modalService.open(this.sizeErrorModal, this.modalOptions);
    }

    for (const file of this.files) {
      if (file.size > Config.maxFileSize) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.digitalNote.get("terms_agreed").value === true) {
        this.digitalNote.patchValue({ terms_agreed: false });
      }
    } else {
      this.digitalNote.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);
    this.recomputeFileErrors();

    if (this.supportingDocuments.length === 0) {
      if (this.digitalNote.get("terms_agreed").value === true) {
        this.digitalNote.patchValue({ terms_agreed: false });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.digitalNote.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  private recomputeFileErrors() {
    const totalSize = this.supportingDocuments.reduce((sum, f) => sum + (f.size || 0), 0);
    if (totalSize <= Config.maxTotalSupportingDocsSize) this.totalSizeError = false;
    this.sizeError = false;
    this.typeError = false;
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;

    //console.log(this.supportingDocuments);
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  reUploadNote(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      //console.log(fileUploaded);

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > Config.maxFileSize) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
        this.modalService.open(this.sizeErrorModal, this.modalOptions);
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
            //console.log(this.pdfSrc);
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.digitalNote.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;
        this.loading = true;
        this.formSubmitted = true;
        this.invoiceChanged = true;
        //console.log(localStorage.getItem("eippSession"));

        const formData: any = new FormData();
        // formData.append('poNo', this.route.snapshot.params['poNo']);
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("eippSession"));
        formData.append("file", this.digitalNote.value.fileSource);

        this.dsLoaderMsg = "Verifying Signature";

        setTimeout(() => {
          this.dsLoaderMsg = "Authenticating Signature";
        }, 5000);
        setTimeout(() => {
          this.dsLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.dsLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.verifyDigitalSignature(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.formSubmitted = false;
            this.responseData = res;
            //console.log(res);
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              //console.log(this.responseData.msg);
              this.hasError = true;
            } else {
              //console.log("Success hereresponseData");
              // console.log(this.responseData);
              this.formData = this.responseData.data;
              if (typeof this.formData.irn !== "undefined") {
                this.irnExist = true;
              } else {
                this.irnExist = false;
              }
              this.digitalNote.patchValue({
                SellerGstin: this.formData.vendorGSTIN,
                DocNo: this.formData.invoiceNumber,
                DocDt: this.formData.invoiceDate.replaceAll(".", "/"),
                TotInvVal: this.formData.invoiceAmount,
                Irn: this.formData.irn,
              });
              this.fileLink = this.responseData.file_link;
              this.hasError = false;
            }
          },
          (error) => {
            console.log(error.msg);
          }
        );
      }
    }
  }

  fetchPoItems(poNo, poType) {
    if (poType === "SERV") {
      const userData = {
        poNo: poNo,
        action: "get",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (
            this.poResponseData.status == "successful" &&
            this.poResponseData.pos &&
            this.poResponseData.pos.length > 0
          ) {
            this.poResponseData.pos[0].line_items.forEach((p: any) => {
              this.poItems.push({
                poNo: poNo,
                itemNo: p.po_item_line,
                grn: "",
                grn_no: "",
              });
            });
            this.intialLoading = false;
          } else {
            this.intialLoading = false;
          }
        },
        (error) => {
          console.log(error);
          this.intialLoading = false;
        }
      );
    } else {
      const userData = {
        poNo: poNo,
        action: "list",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (
            this.poResponseData.status == "successful" &&
            this.poResponseData.pods &&
            this.poResponseData.pods.length > 0
          ) {
            this.poResponseData.pods.forEach((p: any) => {
              this.poItems.push({
                poNo: p.po_no,
                itemNo: p.po_item_line,
                grn: p._id,
                grn_no: p.grn_no,
              });
            });
            this.intialLoading = false;
          } else {
            this.intialLoading = false;
          }
        },
        (error) => {
          console.log(error);
          this.intialLoading = false;
        }
      );
    }
  }

  onSubmitDigitalNote() {
    this.loading = true;
    this.uploadInvoice = true;
    this.formSubmitted = true;

    // Get data from localStorage similar to upload-preview
    const pods: any = localStorage.getItem("pods");
    const convertPods = pods ? JSON.parse(pods) : [];

    const poItems: any = [];
    if (convertPods && convertPods.length > 0) {
      convertPods.forEach((p: any) => {
        if (p.docNo !== "" && typeof p.docNo !== "undefined") {
          poItems.push({
            poNo: p.poNo,
            itemNo: p.poLineNo,
            grn: p._id,
          });
        } else {
          poItems.push({
            poNo: p.poNo,
            itemNo: p.poLineNo,
            grn: "",
          });
        }
      });
    }

    let companyCode = "";
    let purchaseOrg = "";
    let docType = "";

    if (convertPods && convertPods.length > 0) {
      
      companyCode = convertPods[0].cmpCode;
      purchaseOrg = convertPods[0].purchaseOrg;
      docType = convertPods[0].erpDocType;
    } else {
      companyCode = localStorage.getItem("servCompanyCode");
      purchaseOrg = localStorage.getItem("servPurchaseOrg");
      docType = localStorage.getItem("servDocType");
    }

    const userData = {
      req: {
        emailAddress: this.formData.email_address || "",
        companyCode: companyCode || this.invList[0].cmpCode,
        purchaseOrg: purchaseOrg || this.invList[0].purchaseOrg,
        docType: docType || this.invList[0].erpDocType,
        items: poItems,
        termsAgreed: true,
      },
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.digitalNote.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });
    const led = this.invoiceService.getProcessedInvoice();

    const docCat = localStorage.getItem("selectionType") === "po" ? "po_based" : localStorage.getItem("invoiceType") === "poInvoice" ? "inv_based" : "non_po_based";

    // Prefer form field values so manual edits (when extraction missed GSTIN/dates) are submitted
    const docDtRaw = this.digitalNote.get("DocDt").value || this.formData.invoice_date;
    const sellerGstin = this.digitalNote.get("SellerGstin").value || this.invoiceDetails.gstin;
    const irnValue = this.digitalNote.get("Irn").value || this.formData.irn;

    // Create ledger structure similar to upload-preview
    const timestamp = Date.now();
    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(docDtRaw),
        dueDate: this.dateUtils.formatDateString(docDtRaw),
        dueAmt: parseFloat(this.digitalNote.get("TotInvVal").value) || parseFloat(this.formData.invoice_amount),
        docAmt: parseFloat(this.digitalNote.get("TotInvVal").value) || parseFloat(this.formData.invoice_amount),
        docType: this.invoiceService.getNoteType() || "CN",
        poNo: localStorage.getItem("selectionType") === "po" ? this.poNo : localStorage.getItem("invoiceType") === "poInvoice" ? this.poNo : undefined,
        docNo: this.digitalNote.get("DocNo").value || this.invoiceDetails.invoice_number,
        timestamp: String(timestamp),
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.digitalNote.get("TotInvVal").value || this.formData.invoice_amount,
          docFormat: this.invoiceService.getInvType() || "e-invoice",
          docCat: docCat,
          docGstin: sellerGstin,
          irn: irnValue,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link || "",
          },
        ],
        lineItemDetail: [],
        invDetails: this.barcodes && this.barcodes.length > 0 ? this.barcodes.map((barcode) => ({
          barcode: barcode,
        })) : undefined,
        supplierCode: localStorage.getItem("vendorCode"),
        cmpCode: userData.req.companyCode,
        purchaseOrg: userData.req.purchaseOrg,
        erpDocType: userData.req.docType,
      },
    ];

    // Use the same FormData structure as upload-preview
    const formData: any = new FormData();
    formData.append("sellerCode", localStorage.getItem("sellerCode"));
    formData.append("supplierCode", localStorage.getItem("vendorCode"));
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify({ sessionId: localStorage.getItem("eippSession") }));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    // for (const value of formData.values()) {
    //     console.log(value);
    // }

    this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
      (res) => {
        this.responseData = res;

        if (this.responseData.status === "error") {
          this.loading = false;
          this.uploadInvoice = false;
          this.hasError = true;
          this.formSubmitted = false;
        } else {
          this.barcodeNo = this.responseData.barcode;

          this.uploadInvoice = false;
          this.invoiceSaved = false;
          this.uploadSuccessful = true;
        }
      },
      (error) => {
        this.loading = false;
        this.uploadInvoice = false;
        this.uploadSuccessful = false;
        this.invoiceSaved = false;
        console.log(error);
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getProcessedInvoice();

    this.loadFile();
    this.formSubmitted = false;

    const docCat = localStorage.getItem("selectionType") === "po" ? "po_based" : localStorage.getItem("invoiceType") === "poInvoice" ? "inv_based" : "non_po_based";

    if (docCat === "non_po_based") {
      this.digitalNote.get("PoNo").setValidators([]);
      this.digitalNote.get("PoNo").updateValueAndValidity();
    }


    if (localStorage.getItem("nonPoInvoice") === "yes") {
      this.isNonPOInvoice = true;
    }

    let barcodeString;
    if (localStorage.getItem("selectionType") === "invoice") {
      this.isInvoice = true;
      this.invList = JSON.parse(localStorage.getItem("invoiceList"));
      let barcodes = [];
      this.invList.forEach((inv) => {
        barcodes.push(inv.barcode);
      });

      this.barcodes = barcodes;

      if (barcodes.length === 1) {
        barcodeString = barcodes[0];
      } else {
        barcodeString = barcodes.join(", ");
      }
    }

    this.fileLink = this.invoiceService.fileUrl;

    this.formData = this.invoiceService.getProcessedInvoice();

    if (typeof this.formData.irn !== "undefined") {
      this.irnExist = true;
    }

    let documentDate;
    if (typeof this.formData.invoice_date !== "undefined") {
      documentDate = this.formData.invoice_date.replaceAll(".", "/");
    } else {
      documentDate = "";
    }

    if (localStorage.getItem("selectionType") === "invoice") {
      this.invList = JSON.parse(localStorage.getItem("invoiceList"));
      if (localStorage.getItem("invoiceType") === "poInvoice") {
        this.poNo = this.invList[0].poNo;
      }
    } else {
      this.poNo = this.route.snapshot.params["itemNo"];
    }

    if (localStorage.getItem("invoiceType") === "poInvoice" || localStorage.getItem("selectionType") === "po") {
      this.poType = localStorage.getItem("poType");
      this.fetchPoItems(this.poNo, this.poType);
    }

    if (this.poNo === null || this.poNo === "null" || this.poNo === "") {
      this.emptyPo = true;
    }

    this.digitalNote.patchValue({
      SellerGstin: this.formData.gstin,
      DocNo: this.formData.invoice_number,
      DocDt: documentDate,
      Doctype: localStorage.getItem("document"),
      TotInvVal: this.formData.invoice_amount,
      Irn: this.formData.irn,
      PoNo: this.poNo,
      barcode: barcodeString,
    });

    this.setAsDirty();
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/credit-notes");
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["itemNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
        //console.log(this.pdfSrc);
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }

  onCheckboxChange(e: any) {
    //console.log(e);
    if (e.target.checked) {
      this.digitalNote.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.digitalNote.patchValue({
        terms_agreed: null,
      });
    }
  }
}
